
<div class="background-animation">
    <div class="wave"></div>
    <div class="wave"></div>
    <div class="wave"></div>
</div>
<div
    class="d-flex flex-column justify-content-center align-items-center mt-5 pt-5">
    <h5>Enter Meeting ID</h5>
    <input
        type="text"
        #meetinglink
        [value]="getLastMeetingLink()"
        placeholder="Enter Meeting ID" 
        class="m-3 text-center w-50"/>
    <button 
        [disabled]="loading"
        (click)="setMeetingLink(meetinglink.value)"
        class="btn btn-primary">
            <span>OK</span>
    </button>
</div>
